<template>
    <PerfectScrollbar class="AllPwaMobile">

      <div class="AllSiteHeaderMenu">
        <div class="MenuAllSiteHeaderMenuDeposit">
          <div class="ChildSelectTab">
          
          </div>

          <p>
            {{ $t('internalTransfer.title') }}
          </p>
        </div>
      </div>

      <div class="internal-balance-summary withdraw-balance-card">
        <div class="dashboard-balance-heading">
          <h3 class="dashboard-balance-title">{{ $t('dashboard.availableBalance') }}</h3>
          <span v-if="hasDollarWallet && usdtRate > 0" class="dashboard-rate-pill">
            تتر {{ formatPrice(usdtRate) }} تومان
          </span>
        </div>
        <div v-if="visibleBalanceWallets.length" class="dashboard-wallet-list">
          <div v-for="(wallet, index) in visibleBalanceWallets" :key="index" class="dashboard-wallet-item">
            <div class="dashboard-wallet-main">
              <span class="dashboard-wallet-name">{{ wallet.currency_name || wallet.currency_code }}</span>
              <strong class="dashboard-wallet-amount">
                {{ formatCurrency(displayAvailableBalance(wallet)) }} {{ wallet.currency_code }}
              </strong>
            </div>
            <small
              v-if="usdtRate > 0 && ['USD', 'USDT'].includes((wallet.currency_code || '').toUpperCase())"
              class="dashboard-wallet-conversion"
            >
              ارزش تقریبی: {{ formatTomanEquivalentFromUSDT(displayAvailableBalance(wallet)) }} تومان
            </small>
          </div>
        </div>
        <p v-else class="dashboard-wallet-empty">—</p>
        <WalletFundsBreakdown :wallets="walletBalances" :withdrawals="withdrawalRecords" />
      </div>

      <div class="GetDollarSelect">

        <div class="ShowSelectSearch" style="margin-top: 20px !important;">
          <div class="ShowSelectSearchMarginTop">
            <div class="TabChildSelectTab">
              <vs-radio color="#BB86FC" v-model="currencyType" vs-name="currencyType" vs-value="dollar">{{ $t('withdraw.currencyType.dollar') }}</vs-radio>
            </div>
            <!-- <div class="TabChildSelectTab">
              <vs-radio color="#BB86FC" v-model="currencyType" vs-name="currencyType" vs-value="rial">{{ $t('withdraw.currencyType.rial') }}</vs-radio>
            </div> -->
          </div>
        </div>

        <div v-if="currencyType === 'rial'" style="margin-top: 20px !important;" class="ShowSelectSearch">
          <label>{{ $t('withdraw.destination.cardNumber') }}</label>
          <multiselect :placeholder="$t('withdraw.destination.selectPlaceholder')" v-model="selectedBankAccount" :options="rialBankOptions" label="name" track-by="name"></multiselect>
        </div>


        <div style="margin-top: 20px !important;" class="ShowSelectSearch recipient-verification">
          <label>{{ $t('internalTransfer.recipientIdentifier') }}</label>
          <div class="recipient-verification-fields">
            <input class="InputX" type="text" autocomplete="off" v-model="recipientIdentifier" @input="clearRecipientVerification" :placeholder="$t('internalTransfer.phoneOrEmail')">
            <button type="button" class="recipient-check-button" :disabled="recipientLookupLoading || !recipientIdentifier.trim()" @click="verifyRecipient">
              {{ recipientLookupLoading ? $t('internalTransfer.checkingRecipient') : $t('internalTransfer.checkRecipient') }}
            </button>
          </div>
          <p v-if="verifiedRecipient" class="recipient-verified-name" role="status">
            {{ $t('internalTransfer.verifiedRecipientName') }}: <strong>{{ verifiedRecipient.name }}</strong>
          </p>
        </div>

        <div style="margin-top: 20px !important;" class="ShowSelectSearch">    
          <label>{{ $t('internalTransfer.transferAmount') }}</label>
          <input class="InputX" type="number" min="0" step="any" :max="availableTransferBalance" placeholder="0" v-model="moneyDollar">

          <div v-if="color != '#2E1977'" style="color: #6dec6d; width: 80px; font-size: .8rem; top: 43px" class="ShowDollarName">{{ $t('internalTransfer.noFee') }}</div>
          <div v-if="color == '#2E1977'" style="color: #2a1149; width: 80px; font-size: .8rem; top: 43px" class="ShowDollarName">{{ $t('internalTransfer.noFee') }}</div>
        </div>
      </div>

      <div style="margin-top: 40px;">
        <!-- <div class="InformationSelectBotton">
            <p>
                {{ $t('internalTransfer.uidNote') }}
            </p>
            <VsxIcon iconName="InfoCircle" :size="22" :color="color" type="linear" />
        </div> -->

        <!-- <div class="InformationSelectBotton" v-if="currencyType === 'dollar'">
          <p>{{ $t('withdraw.info.walletAddress') }}</p>
          <VsxIcon iconName="InfoCircle" :size="22" :color="color" type="linear" />
        </div> -->
        <!-- <div class="InformationSelectBotton" v-if="currencyType === 'rial'">
          <p>{{ $t('withdraw.info.cardNumber') }}</p>
          <VsxIcon iconName="InfoCircle" :size="22" :color="color" type="linear" />
        </div> -->

        <div class="InformationSelectBotton">
            <p>
                {{ $t('internalTransfer.feeAmount') }}
            </p>
            <VsxIcon iconName="InfoCircle" :size="22" :color="color" type="linear" />
        </div>
      </div>

      <div @click="ClickShowMargin" style="margin-top: 40px;" class="ButtonShowSelectSearch">
        {{ $t('internalTransfer.confirm') }}
      </div>
  
    </PerfectScrollbar>
</template>
<script>
  import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
  import Multiselect from 'vue-multiselect';
  import {toast} from "vue3-toastify";
  import axios from "@/axios";
  import WalletFundsBreakdown from './WalletFundsBreakdown.vue';

  export default {
    name: 'InternalUser',
    components: {
      PerfectScrollbar,
      Multiselect,
      WalletFundsBreakdown,
    },
    data(){
      return{
        color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
        recipientIdentifier: '',
        verifiedRecipient: null,
        recipientLookupLoading: false,
        moneyDollar: '',
        currencyType: 'dollar',
        // for legacy display of two internal logical wallets, keep balances
        userLis: [],
        selectedBankAccount: null,
        usernameError: '',
        amountError: '',
        walletError: '',
        rialBankOptions: [],
        toastedErrors: new Set(), // برای جلوگیری از نمایش یک خطا چندین بار
        walletBalances: [],
        usdtRate: 0,
        usdtRateTimer: null,
        pendingWithdrawalBalances: {},
        outgoingBalances: {},
        withdrawalRecords: []
      }
    },
    computed: {
      visibleBalanceWallets() {
        return this.walletBalances.filter(wallet => (wallet.currency_code || '').toUpperCase() !== 'IRR');
      },
      hasDollarWallet() {
        return this.visibleBalanceWallets.some(wallet => ['USD', 'USDT'].includes((wallet.currency_code || '').toUpperCase()));
      },
      availableTransferBalance() {
        const currencyCodes = this.currencyType === 'dollar' ? ['USD', 'USDT'] : ['IRR'];
        const balance = this.walletBalances
          .filter(wallet => currencyCodes.includes((wallet.currency_code || '').toUpperCase()))
          .reduce((total, wallet) => total + Number(wallet.available_balance ?? wallet.balance ?? 0), 0);
        const outflowKey = this.currencyType === 'dollar' ? 'USD' : 'IRR';
        return Math.max(0, balance - Number(this.outgoingBalances[outflowKey] || 0));
      }
    },
    methods:{
      async fetchUSDTPrice() {
        try {
          const response = await axios.get('https://apiv2.nobitex.ir/market/stats?srcCurrency=usdt&dstCurrency=rls', {
            timeout: 5000
          });
          const latestRialPrice = Number(response.data?.stats?.['usdt-rls']?.latest);
          if (response.data?.status !== 'ok' || !Number.isFinite(latestRialPrice) || latestRialPrice <= 0) {
            throw new Error('Invalid USDT/IRR price response from Nobitex');
          }

          this.usdtRate = latestRialPrice / 10;
        } catch (error) {
          console.error('Error fetching USDT price from Nobitex:', error);
        }
      },

      formatTomanEquivalentFromUSDT(usdtAmount) {
        const amount = Number(usdtAmount);
        if (!Number.isFinite(amount) || amount <= 0 || this.usdtRate <= 0) return '0';
        return Math.round(amount * this.usdtRate).toLocaleString('en-US');
      },

      async ClickShowMargin(){
        // Reset error messages
        this.usernameError = '';
        this.amountError = '';
        this.walletError = '';
        this.toastedErrors.clear();
        
        // Validate form fields
        let isValid = true;
        const amountInput = String(this.moneyDollar ?? '').replace(/,/g, '').trim();
        const requestedAmount = Number(amountInput);
        
        if (!this.recipientIdentifier || this.recipientIdentifier.trim() === '') {
          const errorMsg = this.$t('internalTransfer.usernameRequired');
          this.showToast(errorMsg);
          isValid = false;
        }
        if (!this.verifiedRecipient) {
          this.showToast(this.$t('internalTransfer.verifyRecipientFirst'));
          isValid = false;
        }
        
        if (!amountInput) {
          const errorMsg = this.$t('internalTransfer.amountRequired');
          this.showToast(errorMsg);
          isValid = false;
        } else if (!Number.isFinite(requestedAmount) || requestedAmount <= 0) {
          const errorMsg = "لطفاً مبلغ معتبر وارد کنید";
          this.showToast(errorMsg);
          isValid = false;
        }

        if (Number.isFinite(requestedAmount) && requestedAmount > this.availableTransferBalance) {
          this.showToast(this.$t('internalTransfer.insufficientBalance'));
          isValid = false;
        }
        
        // currency-specific validation
        if (this.currencyType === 'dollar') {
          // Dollar transfers draw from the system wallet; no user wallet is selected.
        } else {
          if (!this.selectedBankAccount || !this.selectedBankAccount.value) {
            const errorMsg = this.$t('withdraw.errors.bankAccountRequired');
            this.showToast(errorMsg);
            isValid = false;
          }
        }
        
        if (!isValid) {
          return;
        }

        try {
          const method_code = this.currencyType === 'dollar' ? 1 : 2;
          const payload = {
            recipient_identifier: this.recipientIdentifier.trim(),
            amount: amountInput,
            method_code,
            user_id: this.userLis.id
          };
          if (method_code === 2) {
            payload.bank_account_id = this.selectedBankAccount.value;
          }

          const response = await axios.post('/transfer-user', payload);

          if(response.data[0] == "error"){
            this.showToast(response.data[1], "error");
          }

          if(response.data == "success"){
            this.showToast(this.$t('internalTransfer.successMessage'), "success");
            await this.getUserData();
            // Reset form on success
            this.recipientIdentifier = '';
            this.verifiedRecipient = null;
            this.moneyDollar = '';
            this.selectedBankAccount = null;
          }

          if(response.data == "stop"){
            this.showToast(this.$t('internalTransfer.notAuthorized'), "error");
          }
        } catch (error) {
          // بررسی اینکه آیا خطا از نوع Axios است
          if (error.response && error.response.data && error.response.data.errors) {
            // خطاهای اعتبارسنجی را دریافت کنید
            const errors = error.response.data.errors;
            
            // نمایش خطاها و تنظیم فیلدهای خطا
            const keys = Object.keys(errors);
            for (const key of keys) {
              const errorMessage = errors[key].join(', ');
              
              // نمایش هر خطا در toast
              this.showToast(errorMessage, "error");
            }
          } else {
            console.error('An unexpected error occurred:', error.message);
            this.showToast(this.$t('internalTransfer.unexpectedError'), "error");
          }
        }
      },
      
      // متد برای نمایش toast بدون تکرار
      showToast(message, type = "error") {
        // اگر این پیام قبلاً نمایش داده نشده، نمایش بده
        if (!this.toastedErrors.has(message)) {
          this.toastedErrors.add(message);
          toast(message, {
            autoClose: 3000,
            position: "top-right",
            type: type,
          });
        }
      },

      clearRecipientVerification() {
        this.verifiedRecipient = null;
      },

      async verifyRecipient() {
        const identifier = this.recipientIdentifier.trim();
        if (!identifier) {
          this.showToast(this.$t('internalTransfer.usernameRequired'));
          return;
        }

        this.recipientLookupLoading = true;
        this.verifiedRecipient = null;
        try {
          const response = await axios.post('/transfer-recipient/verify', {
            user_id: this.userLis.id,
            identifier,
          });
          if (this.recipientIdentifier.trim() !== identifier) return;
          if (response.data?.success && response.data?.data?.id) {
            this.verifiedRecipient = response.data.data;
          } else {
            this.showToast(response.data?.message || this.$t('internalTransfer.recipientNotFound'));
          }
        } catch (error) {
          this.showToast(error.response?.data?.message || this.$t('internalTransfer.recipientNotFound'));
        } finally {
          this.recipientLookupLoading = false;
        }
      },

      async getUserData(){
        const userData = localStorage.getItem('user');
        if (userData) {
          this.userLis = JSON.parse(userData);
        }

        // بارگذاری لیست کیف پول‌های ارزی و حساب‌های بانکی برای انتخاب
        try {
          const res = await axios.post('/get-wallet', { user_id: this.userLis.id });
          const userBanks = res.data[2] || [];

          this.rialBankOptions = userBanks.map(b => ({ name: `${b.bank} - ${b.card_number}`, value: b.id }));
        } catch (e) {
          console.log('Error fetching wallets/banks');
        }

        try {
          const response = await axios.post('/get-wallet-users', { user_id: this.userLis.id });
          this.walletBalances = response.data?.success && Array.isArray(response.data.data)
            ? response.data.data
            : [];
        } catch (error) {
          console.log('Error fetching system wallet balances');
          this.walletBalances = [];
        }

        try {
          const response = await axios.post('/withdraw-user', { user_id: this.userLis.id });
          const withdrawals = response.data?.[1]?.[0]?.data || [];
          this.withdrawalRecords = withdrawals;
          this.pendingWithdrawalBalances = {};
          this.outgoingBalances = {};
          withdrawals.forEach(withdrawal => {
            const status = Number(withdrawal.status);
            // New requests have already been deducted; reserve only legacy pending requests.
            if (status !== 2 || withdrawal.balance_deducted) return;
            const code = (withdrawal.currency || '').toUpperCase();
            const key = ['USD', 'USDT'].includes(code) ? 'USD' : code;
            const amount = Number(withdrawal.total_debited || withdrawal.amount || 0);
            this.outgoingBalances[key] = (this.outgoingBalances[key] || 0) + amount;
            this.pendingWithdrawalBalances[key] = (this.pendingWithdrawalBalances[key] || 0) + amount;
          });
        } catch (error) {
          console.log('Error fetching pending withdrawals');
        }
      },

      getCurrencyKey(currencyCode) {
        const code = (currencyCode || '').toUpperCase();
        return ['USD', 'USDT'].includes(code) ? 'USD' : code;
      },

      getAllocatedOutflow(wallet, amount) {
        const code = (wallet.currency_code || '').toUpperCase();
        if (!['USD', 'USDT'].includes(code)) return Number(amount || 0);

        const usdWallet = this.walletBalances.find(item => (item.currency_code || '').toUpperCase() === 'USD');
        if (code === 'USD') {
          const usdAvailable = Number(usdWallet?.available_balance ?? usdWallet?.balance ?? 0);
          return Math.min(Number(amount || 0), Math.max(usdAvailable, 0));
        }
        if (!usdWallet) return Number(amount || 0);
        const usdAvailable = Number(usdWallet.available_balance ?? usdWallet.balance ?? 0);
        return Math.max(0, Number(amount || 0) - Math.max(usdAvailable, 0));
      },

      displayAvailableBalance(wallet) {
        const available = Number(wallet.available_balance ?? wallet.balance ?? 0);
        return Math.max(0, available - this.getAllocatedOutflow(wallet, this.outgoingBalances[this.getCurrencyKey(wallet.currency_code)]));
      },

      pendingWithdrawalFor(wallet) {
        return this.getAllocatedOutflow(wallet, this.pendingWithdrawalBalances[this.getCurrencyKey(wallet.currency_code)]);
      },

      formatBalanceForCurrency(currencyCode, amount) {
        if ((currencyCode || '').toUpperCase() === 'IRR') {
          return `${this.formatPrice(Number(amount || 0) / 10)} تومان`;
        }
        return `${this.formatCurrency(amount)} ${currencyCode}`;
      },

      formatCurrency(amount) {
        const numericAmount = parseFloat(amount); // تبدیل به عدد
        if (isNaN(numericAmount)) {
          return '$0.00'; // اگر مقدار عددی نبود
        }
        return numericAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // فرمت‌دهی با کاما
      },

      formatPrice(value) {
        const amount = Number(value || 0);
        if (!Number.isFinite(amount)) return '0';
        return Math.round(amount).toLocaleString('en-US');
      },

      loadTheme() {
        const savedTheme = localStorage.getItem('theme');
        if( savedTheme == "light"){
          this.color = '#2E1977'
        }else{
          this.color = '#BB86FC'
        }
      }
    },
    mounted(){
      this.getUserData()
      this.fetchUSDTPrice()
      this.usdtRateTimer = setInterval(() => {
        this.fetchUSDTPrice()
      }, 30000);
      setInterval(() => {
        this.loadTheme()
      }, 100);
    },
    beforeUnmount() {
      if (this.usdtRateTimer) {
        clearInterval(this.usdtRateTimer);
        this.usdtRateTimer = null;
      }
    }
  }
</script>

<style scoped>
.internal-balance-summary {
  margin: 14px 16px 0;
}

.recipient-verification-fields {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.recipient-check-button {
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid currentColor;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.recipient-check-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.recipient-check-button:focus-visible {
  outline: 2px solid #bb86fc;
  outline-offset: 2px;
}

.recipient-verified-name {
  margin: 8px 0 0;
  color: #268b45;
}

@media (max-width: 640px) {
  .recipient-verification-fields {
    grid-template-columns: 1fr;
  }
}
</style>
  
  